<template>
  <div class="panel-body">
    <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
    <hr class="my-4">
    <vue-form-generator :schema="schema" :model="model" ref="newMemberForm" :options="formOptions"></vue-form-generator>

    <!-- Selector buscable de Institución (visible cuando perfil = 2) -->
    <div v-if="model.perfil === 2" class="row mt-2 mb-3 px-3">
      <div class="col-md-5">
        <label class="col-form-label fw-semibold">Institución <span class="text-danger">*</span></label>
        <b-form-input
          v-model="buscarInstitucion"
          placeholder="🔍 Buscar institución..."
          class="mb-1"
        />
        <b-form-select
          v-model="model.institucion"
          :options="institucionesFiltradas"
          value-field="id"
          text-field="name"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- Seleccione una institución --</b-form-select-option>
          </template>
        </b-form-select>
      </div>
    </div>

    <!-- Selector buscable de Proveedor (visible cuando perfil = 3) -->
    <div v-if="model.perfil === 3" class="row mt-2 mb-3 px-3">
      <div class="col-md-5">
        <label class="col-form-label fw-semibold">Proveedor <span class="text-danger">*</span></label>
        <b-form-input
          v-model="buscarProveedor"
          placeholder="🔍 Buscar proveedor..."
          class="mb-1"
        />
        <b-form-select
          v-model="model.proveedor"
          :options="proveedoresFiltrados"
          value-field="id"
          text-field="name"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- Seleccione un proveedor --</b-form-select-option>
          </template>
        </b-form-select>
      </div>
    </div>

    <b-button v-if=" this.editar != false" @click="add()" v-bind:style="[errors ? { 'top': ' 91%' } : { 'top': '82%' }]" class=" botonadd">
      <b-icon class="icono" icon="plus" />
    </b-button>
    <div>
    </div>
    <div class="contenidotabla" v-if="company != ''">
      <b-row class="hed tabla">
        <b-col cols="3">Empresa</b-col>
        <b-col cols="3"> Módulo </b-col>
        <b-col cols="3"> Perfil </b-col>
        <b-col cols="3"> Opciones </b-col>
      </b-row>
      <div v-for="(companie, index) in company" :key="index">
        <b-row class="hed dato">
          <b-col cols="3"> {{ companie.empresa }}</b-col>
          <b-col cols="3"> {{ companie.modulo }}</b-col>
          <b-col cols="3"
            v-b-popover.focus.top="'-BO Registro de Usuarios -Asignación de Perfiles de Analítica -Visualización de Tableros y Generación de Informes relacionados a su Empresa.'"
            tabindex="0" title="Permisos asociados">{{ companie.perfil }}</b-col>
          <b-col cols="3"> <b-icon @click="remove(index)" class="dele" icon="trash-fill" /></b-col>
        </b-row>
      </div>


    </div>
    <b-alert class="alertared" :show="dismissCountDown" dismissible @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged" variant="danger">{{ mensaje }}</b-alert>
    <b-alert class="alertared" :show="disiss" dismissible @dismissed="disiss = 0" @dismiss-count-down="disissDownChanged"
      variant="success">Usuario creado exitosamente, el usuario {{ model.pnombre }} deberá seguir las instrucciones del
      Correo Electrónico para finalizar su proceso de registro</b-alert>

    <div  class="centro">
      <div>
        <b-button v-if=" this.editar != false && this.editar != true " @click="registrar" class=" botonregidtro"><span v-if="this.load == false"
            class="ingresar poppins-semi-bold-white-14px">Registrar</span>
          <div v-if="this.load == true"><b-spinner small></b-spinner><span
              class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div>
        </b-button>
        <b-button v-if=" this.editar == true" @click="guardarEdicion" class=" botonregidtro"><span v-if="this.load == false"
            class="ingresar poppins-semi-bold-white-14px">Editar</span>
          <div v-if="this.load == true"><b-spinner small></b-spinner><span
              class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";
import { getCountries } from 'country-flag-icons'

Vue.use(VueFormGenerator)

const registro = RepositoryFactory.get("registro");
const config = RepositoryFactory.get("config");
export default {
  components: {
    "vue-form-generator": VueFormGenerator.component,
    HeaderGeneral
  },

  data() {
    return {
      vista: "Usuarios",
      proveniente: " - Creación de usuarios ",
      dismissSecs: 5,
      dismissCountDown: 0,
      disiss: 0,
      dis: 10,
      load: false, 
      company: [],
      pp: "",
      mensaje: "",
      errors:"",
      instituciones: [], // Aquí se guardan las instituciones
      proveedores: [], // Aquí se guardan los proveedores
      model: {
        pnombre: '',
        snombre: '',
        papellido: "",
        sapellido: "",
        tipo_identificacion: null,
        identificacion: "",
        country: "+57",
        celular: "",
        email: '',
        empresa: 1,
        modulo: 1,
        perfil: null,
        datos: [],
        equis: false,
        institucion: null, // Nuevo campo
        proveedor: null, // Nuevo campo
      },
      buscarInstitucion: '',
      buscarProveedor: '',

      schema: {
        fields: [
          {
            type: 'select',
            label: 'Tipo de Identificación ',
            model: 'tipo_identificacion',
            values: [{ id: 1, name: 'Cédula de Ciudadanía' },
            { id: 2, name: 'Cédula de Extranjería' },
            { id: 3, name: 'Tarjeta de Identidad' },
            { id: 4, name: 'Registro Civil Temporal' },
            { id: 5, name: 'NUIP' },
            { id: 6, name: 'Certificado Nacido Vivo' },
            { id: 7, name: 'Diplomático,Documento de Identidad de Extranjeros' },
            { id: 8, name: 'ID Fiscal para el Exterior' },
            { id: 9, name: 'Permiso Especial de Permanencia' },
            { id: 10, name: 'Permiso Especial de Permanencia' },
            { id: 11, name: 'Pasaporte' },
            { id: 12, name: 'Pasaporte ONU' },
            { id: 13, name: 'Salvoconducto de Permanencia' }],
            required: true,
            styleClasses: 'col-md-5',
            validator: ["required"],
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',
            },


          },
          {
            type: 'input',
            inputType: 'text',
            inputName: "identificacion",
            label: 'Número de identificación',
            model: 'identificacion',
            required: true,
            readonly: false,
            disabled: false,
            max: 15,
            validator: ["required", "string"],
            styleClasses: 'offset-md-2 col-md-5',
            disabled: (model) => {
              if (model.tipo_identificacion == '' || model.tipo_identificacion == undefined) return true;
              return false;
            },
            visible: function (model) {
              //visible if business is selected
              return model.tipo_identificacion == 'Cédula de Extranjería';
            }
          },
          {
            type: 'input',
            inputType: 'number',
            inputName: "identificacion",
            label: 'Número de identificación',
            model: 'identificacion',
            required: true,
            readonly: false,
            disabled: false,
            max: 999999999999999,
            validator: ["required", "number"],
            styleClasses: 'offset-md-2 col-md-5',
            disabled: (model) => {
              if (model.tipo_identificacion == '' || model.tipo_identificacion == undefined) return true;
              return false;
            },
            visible: function (model) {
              return model.tipo_identificacion != 'Cédula de Extranjería';
            }
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Primer Nombre',
            model: 'pnombre',
            required: true,
            styleClasses: 'col-md-5 transform:uppercase ',
            max: 70,
            validator: ["required", "string", "alpha"],
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Segundo Nombre',
            model: 'snombre',
            required: false,
            max: 70,
            styleClasses: 'offset-md-2 col-md-5',
            validator: ["string", "alpha"],
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Primer Apellido',
            model: 'papellido',
            required: true,
            max: 70,
            styleClasses: 'col-md-5',
            validator: ["required", "string", "alpha"],
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Segundo Apellido',
            model: 'sapellido',
            required: false,
            max: 70,
            styleClasses: ' offset-md-2 col-md-5',
            validator: ["string", "alpha"],
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },
          },
          {
            type: "select",
            label: "Celular",
            model: "country",
            values: ['+1', '+51', '+52', '+54', '+55', '+56', '+57', '+58', '+591', '+592', '+593', '+594'],
            styleClasses: 'col-md-1',
            required: true,
            validator: ["required"],
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',

            },
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },

          },
          {
            type: 'input',
            label: '',
            id: "phone",
            inputType: 'text',
            model: 'celular',
            max: 10,
            styleClasses: 'col-md-4',
            validator: ["required", "string"],
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },
          },
          {
            type: 'input',
            inputType: 'email',
            label: 'Correo Electrónico',
            model: 'email',
            max: 100,
            required: true,
            styleClasses: 'offset-md-2 col-md-5',
            validator: ["required", "email"],
            disabled: (model) => {
              if (this.editar == false) return true;
              return false;
            },
          },
          {
            type: 'select',
            label: 'Empresa',
            model: 'empresa',
            values: [
              { id: 1, name: 'Cielum' },
              { id: 2, name: 'SURA' },
              { id: 3, name: 'Helpharma' },
              { id: 4, name: 'Janssen' },],
            required: true,
            styleClasses: 'col-md-3',
            validator: ["required"],
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',

            },
            visible: false, // Oculta el campo
            disabled: true, // Lo deshabilita

            // disabled: (model) => {
            //   if ( this.editar == false) return true;
            //   return false;
            // },
          },
          {
            type: 'select',
            label: 'Módulo',
            model: 'modulo',
            values: [
              { id: 1, name: 'Oxigeno' },],
            required: true,
            styleClasses: 'offset-md-1 col-md-3',
            validator: ["required"],
            icon: 'home',
            // disabled: (model) => {
            //   if (model.empresa == '' || model.empresa == undefined) return true;
            //   return false;
            // },
            disebled: true, // Lo deshabilita
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',

            },
          },
          {
            type: 'select',
            label: 'Perfil ',
            model: 'perfil',
            values: [
              { id: 2, name: 'Institucion' },
              { id: 3, name: 'Proveedor' },
              { id: 4, name: 'Prestador' },],
            required: true,
            styleClasses: 'offset-md-1 col-md-3',
            validator: ["required"],
            disabled: (model) => {
              if (model.modulo == '' || model.modulo == undefined) return true;
              return false;
            },
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',
              value: 'id',    // <-- Esto hace que el valor sea el id (número)
              label: 'name'
            }
          },
          // Institución y Proveedor se renderizan fuera del schema con búsqueda personalizada

        ]
      },
      formOptions: {

        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: false,
        validationErrorClass: "has-error",
        validationSuccessClass: "has-success",
      },


    }
  },
  mounted() {

    let elem = document.getElementById('identificacion');
    elem.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z0-9]/.test(key)) { } else {
        return event.preventDefault();
      }
    });
    elem.addEventListener('input', function () {
      if (this.value.length > 15)
        this.value = this.value.slice(0, 15);
    });
    let nombre = document.getElementById('primer-nombre');
    nombre.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let snombre = document.getElementById('segundo-nombre');
    snombre.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let apellido = document.getElementById('primer-apellido');
    apellido.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let sapellido = document.getElementById('segundo-apellido');
    sapellido.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let celular = document.getElementById('phone');
    celular.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[0-9]/.test(key)) { } else {
        return event.preventDefault();
      }
    });
    celular.addEventListener('input', function () {
      if (this.value.length > 10)
        this.value = this.value.slice(0, 10);
    });
    let email = document.getElementById('correo-electrnico');
    email.addEventListener('input', function () {
      if (this.value.length > 100)
        this.value = this.value.slice(0, 100);
    });
  },
  created() {

    VueFormGenerator.validators.resources.fieldIsRequired = "Campo requerido"
    VueFormGenerator.validators.resources.invalidNumber = "Campo requerido"
    VueFormGenerator.validators.resources.textTooBig = "El campo permite hasta {1} caracteres."
    VueFormGenerator.validators.resources.numberTooBig = "Excediste el limite de digítos"
    VueFormGenerator.validators.resources.invalidTextContainNumber = "¡Texto no válido! No puede contener números ni caracteres especiales"
    VueFormGenerator.validators.resources.invalidEmail = "¡Dirección de correo electrónico no válida!"
    VueFormGenerator.validators.resources.thisNotText = "gg"
    try {
        this.datosUser = this.$route.params.myParam;
        this.editar= this.$route.params.editable;
        this.carpeta = this.$route.params.carpeta;
        console.log("this.datosUser",this.datosUser);
        console.log("this.editar",this.editar);
        console.log("this.carpeta",this.carpeta);
        if(this.editar != undefined){
          console.log("paso editar");
          this.visualizardatos();
        }else{
          this.carpeta= "Configuración"
        }
    } catch (error) {
      
    }

  },
  methods: {
      async cargarInstituciones() {
    // Reemplaza la URL y lógica según tu API real
      try {
        var where = [
          {
            "AND": [
              {
                "id": {
                  "iLike": ""
                }
              }
            ]
          }
        ];
                var params = {

                    "nombreEntidad": "entidad_cliente",
                    "idVersion": 1,
                    "column": "id",
                    "type": "desc",
                    "size": 1000,
                    "page": 1,
                }
      const response = await config.getMetaData(params, where, []);
      this.instituciones = response.message.rows.map(item => ({
        id: item.data.id,
        name: item.data.nombre_cliente
      }));

    } catch (e) {
      this.instituciones = [];
    }
  },
     async cargarProveedores() {
    // Reemplaza la URL y lógica según tu API real
      try {
        var where = [
          {
            "AND": [
              {
                "id": {
                  "iLike": ""
                }
              }
            ]
          }
        ];
                var params = {

                    "nombreEntidad": "entidad_proveedor",
                    "idVersion": 1,
                    "column": "id",
                    "type": "desc",
                    "size": 100,
                    "page": 1,
                }
      const response = await config.getMetaData(params, where, []);
      this.proveedores = response.message.rows.map(item => ({
        id: item.data.id,
        name: item.data.nombre_proveedor
      }));

    } catch (e) {
      this.proveedores = [];
    }
  },
    async visualizardatos(){
      this.model.pnombre = this.datosUser['P.Nombre'];
      this.model.snombre = this.datosUser['S.Nombre'];
      this.model.papellido = this.datosUser['P.Apellido'];
      this.model.sapellido = this.datosUser['S.Apellido'];

      // Map tipo identificacion abbreviation to numeric ID used by the select field
      const tipoIdMap = { 'CC': 1, 'CE': 2, 'TI': 3, 'RC': 4, 'NUIP': 5, 'CNV': 6, 'DI': 7, 'IFE': 8, 'PEP': 9, 'PEP2': 10, 'PA': 11, 'PAONU': 12, 'SC': 13 };
      this.model.tipo_identificacion = tipoIdMap[this.datosUser['T.Identificación']] || null;

      this.model.identificacion = this.datosUser['N°Identificación'];

      // Split combined celular (e.g. "+573016208323") into country code + number
      const celularCompleto = this.datosUser['Celular'] || '';
      const countryCodes = ['+591', '+592', '+593', '+594', '+57', '+56', '+55', '+54', '+52', '+51', '+58', '+1'];
      const countryCode = countryCodes.find(cc => celularCompleto.startsWith(cc));
      if (countryCode) {
        this.model.country = countryCode;
        this.model.celular = celularCompleto.substring(countryCode.length);
      } else {
        this.model.celular = celularCompleto;
      }

      this.model.email = this.datosUser['Email'];
      this.model.perfil = parseInt(this.datosUser['id_perfil']) || null;

      // Cargar lista y preseleccionar según perfil
      if (this.model.perfil === 2) {
        await this.cargarInstituciones();
        this.model.institucion = this.datosUser['id_cliente'] ? parseInt(this.datosUser['id_cliente']) : null;
      } else if (this.model.perfil === 3) {
        await this.cargarProveedores();
        this.model.proveedor = this.datosUser['id_proveedor'] ? parseInt(this.datosUser['id_proveedor']) : null;
      }
    },
    validateName(value) {
      const regex = /^[a-zA-Z\s]*$/;
      if (!regex.test(value)) {
        this.model.pnombre = this.model.pnombre.replace(/[^a-zA-Z\s]/g, "");
      }
    },
    async remove(index) {

      this.company = await this.eliminarElementoYInicializar(this.company, index)


    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    disissDownChanged(disiss) {
      this.disiss = disiss
    },

    eliminarElementoYInicializar(arr, indice) {
      arr.splice(indice, 1); // Elimina el elemento en el índice especificado

      const nuevoArr = []; // Crea un nuevo objeto vacío

      for (let i = 0; i < arr.length; i++) {
        nuevoArr[i] = arr[i]; // Asigna los elementos del arreglo con las nuevas llaves
      }


      return nuevoArr;
    },
    add() {
      if (this.model.empresa == '' || this.model.modulo == '' || this.model.perfil == '') {
        this.dismissCountDown = this.dismissSecs;
        this.mensaje = "Debes estar asociado a  un módulo"
      } else {

        var existencia = this.company.find((x) => x.empresa == this.model.empresa && x.modulo == this.model.modulo && x.perfil == this.model.perfil)

        if (existencia) {
          this.dismissCountDown = this.dismissSecs;
          this.mensaje = "Ya se encuentra asociado"
        } else {
          var datos = {
            empresa: this.model.empresa,
            modulo: this.model.modulo,
            perfil: this.model.perfil,
            concat: this.model.empresa + " - " + this.model.modulo + " - " + this.model.perfil
          }
          this.company.push(datos)

        }



      }
    },
    handleKeypress(event) {
      if (this.identificationType == 'CC' | this.identificationType == 'TI' || this.identificationType == 'NI' || this.identificationType == 'NU') {

        if (e.key.match(/[0-9\s]/i) === null) {
          e.preventDefault();
        }
      } else {
        if (e.key.match(/[a-z0-9\s]/i) === null) {
          e.preventDefault();
        }
      }

    },
    async guardarEdicion() {
      this.errors = this.$refs.newMemberForm.validate();
      if (this.errors == true) {
        this.load = true;
        try {
          await config.updateDatosPerfil({
            id_usuario: this.datosUser['id_usuario'],
            id_tipo_usuario: this.datosUser['id_tipo_usuario'],
            modulo: 1,
            tenant: 1,
            perfil: this.model.perfil,
            tipo_id: this.model.tipo_identificacion,
            numero_id: this.model.identificacion,
            primer_nombre: this.model.pnombre.toUpperCase(),
            segundo_nombre: this.model.snombre ? this.model.snombre.toUpperCase() : '',
            primer_apellido: this.model.papellido.toUpperCase(),
            segundo_apellido: this.model.sapellido ? this.model.sapellido.toUpperCase() : '',
            celular: this.model.country + this.model.celular,
            id_proveedor: this.model.proveedor ? parseInt(this.model.proveedor) : null,
            id_cliente: this.model.institucion ? parseInt(this.model.institucion) : null
          });
          this.load = false;
          this.disiss = this.dis;
          this.mensaje = 'Usuario actualizado correctamente';
          setTimeout(() => {
            this.$router.push('/lista-usuarios');
          }, 2000);
        } catch (error) {
          this.load = false;
          this.dismissCountDown = this.dismissSecs;
          this.mensaje = 'Error al actualizar el usuario';
        }
      } else {
        this.equis = false;
      }
    },

    async registrar() {

      this.errors = this.$refs.newMemberForm.validate();


      if (this.errors == true) {
        this.load = true;
        this.equis = true;
        try {
          const response = await registro.registro({
            "email": this.model.email,
            "modulo": 1,
            "tenant": 1,
            "perfil": this.model.perfil,
            "tipoid": this.model.tipo_identificacion,
            "numeroid": this.model.identificacion,
            "primer_nombre": this.model.pnombre.toUpperCase(),
            "segundo_nombre": this.model.snombre.toUpperCase(),
            "primer_apellido": this.model.papellido.toUpperCase(),
            "segundo_apellido": this.model.sapellido.toUpperCase(),
            "celular": this.model.celular,
            "id_cliente": parseInt(this.model.institucion) || null,
            "id_proveedor": parseInt(this.model.proveedor) || null,
          });
          this.disiss = this.dis;
          this.load = false;
          setTimeout(() => {
            this.$router.go('/registro');
          }, 8000);




        } catch (error) {
          this.load = false;
          if (error.response.data.error.message == 'Error inesperado en user PostgresError: duplicate key value violates unique constraint "usuarios_nombre_usuario_key"') {
            this.dismissCountDown = this.dismissSecs;
            this.mensaje = "El correo ingresado ya se encuentra registrado"
          }

        }
      } else {
        this.equis = false;
      }
    }
  },
  computed: {
    institucionesFiltradas() {
      const q = this.buscarInstitucion.toLowerCase();
      const lista = q
        ? this.instituciones.filter(i => i.name.toLowerCase().includes(q))
        : [...this.instituciones];
      return lista.sort((a, b) => a.name.localeCompare(b.name, 'es'));
    },
    proveedoresFiltrados() {
      const q = this.buscarProveedor.toLowerCase();
      const lista = q
        ? this.proveedores.filter(p => p.name.toLowerCase().includes(q))
        : [...this.proveedores];
      return lista.sort((a, b) => a.name.localeCompare(b.name, 'es'));
    },
  },
  watch: {
  'model.perfil': {
    handler(val) {
      if (val === 2) {
        this.cargarInstituciones();
      } else if (val === 3) {
        this.cargarProveedores();
      }
    },
    immediate: false,
  },
},
}
</script>
<style>
.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
}

.form-group.disabled>label {
  color: #212529 !important;
  font-style: normal !important;
}

/* a continuación hay que poner la instrucción concreta de cada icono. fijaros que en realidad mediante el pseudo-selector ::before introducimos contenido delante de la etiqueta*/

.fa-thumbs-down:before {
  content: "\f165";
}

.nombre {
  transform: uppercase !important;
}

.alertared {
  margin-top: 2%;
}

.dele {
  color: white;
  background: var(--blue-violet);
  border-radius: 5px;
  zoom: 1.8;
  padding: 2%;
}

.hed {
  font-family: var(--font-family-poppins);

  padding: 1%;
  text-align: center;
}

.dato {
  border-top: 1px solid gainsboro;
}

.contenidotabla {
  background: white;
  margin: 0%;
  border-radius: 8px;
  border: 1px solid gainsboro;
  padding: 1%;
  margin-top: 3%;
}

.tabla {
  color: var(--blue-violet);
  font-weight: 600;
  border-bottom: 1px solid gainsboro;
}

.close {
  background: transparent;
  border: none;
  color: white;
  zoom: 1.5;
  margin-top: -0.6%;
  float: right;
}

.alert-dismissible {
  padding-right: 1rem !important;
}

.alert-danger {
  --bs-alert-color: white !important;
  --bs-alert-bg: red !important;
  --bs-alert-border-color: #f5c2c7;
  font-family: var(--font-family-poppins);
  font-size: 14px;
}

.icono {
  zoom: 2;
  margin-left: -32%;
  margin-top: -8%;

}

.vue-form-generator .hint {
  font-style: italic;
  font-size: 10px;
}

.has-error>.fiel-wrap {
  border: 1px solid red;
}

.errors {
  color: red;
  font-size: 11px !important;
}

.panel-body {
  margin: 2% 5%;
  font-family: var(--font-family-poppins);
}

.my-4 {
  color: var(--blue-violet);
}

.regis {
  font-size: 33px !important;
  text-align: center !important;
  font-weight: 600 !important;
  color: var(--blue-violet);
}

.centro {
  text-align: center;
}

hr {
  opacity: 1 !important;
}

.botonregidtro {
  width: 20%;
  margin-top: 2%;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
}

.botonadd {
  width: 50px;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
  position: absolute;
  right: 5%;
  top: 77%;
}</style>